import { render, staticRenderFns } from "./ZaehlerstandFields.vue?vue&type=template&id=0162476c&"
import script from "./ZaehlerstandFields.vue?vue&type=script&lang=js&"
export * from "./ZaehlerstandFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports